/* eslint-disable array-callback-return */
import React, { useState, useEffect,Fragment } from 'react';
import { Row, Col, ListGroup, ListGroupItem } from 'reactstrap';
import Chart from 'react-google-charts';
import { ignoreValues, pieOptions } from './data';
import './styles.css';
import { eligible, objectCheck, sysInfoSortArr } from './constants';
import { DATE_FORMATS } from '../../../../../lib/constants';
import utils from '../../../../../lib/utils';
import logoLoading from '../../../../../Res/logo-loading.gif';
import moment from 'moment';
import fetchLogo from '../../../../../Res/Icon/Fetch-Results.svg'
import pingSysinfoLogo  from '../../../../../Res/Icon/arrow-down-to-line-solid.svg'
import TooltipIcon from '../../TooltipIcon/TooltipIcon';
import { getPermissionForComponent } from '../../../../../utils/permissionsUtils';
import { useSelector } from 'react-redux';

export const TIME_STAMP = 'Time Stamp';
export const DATA_LATENCY = 'dataCenterLatency';

const SysInfo = React.memo(({ sysLoading, sysinfo, onReloadInfo,onReloadSysInfo, userRole }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [chartType, setChartType] = useState('PieChart');
  const [chartData, setChartData] = useState(null);
  const [selectedItem, setSelectedItem] = useState('networkInfo');
  const [sortedArray, setSortedArray] = useState([]);
  const [switchStatus, setSwitchStatus] = useState(true);

  const [showChartError, setShowChartError] = useState(false);
  const [time, setTime] = useState();

  const user = useSelector(state => state.AppState.user);

  const handlePieChart = (objName, sysInfoObj, valuesToNeglect) => {
    const arrToReturn = [];
    const obj = { ...sysInfoObj };
    valuesToNeglect.forEach(key => {
      delete obj[key];
    });

    arrToReturn.push([objName, 'Value']);

    Object.entries(obj).forEach(([key, value]) => {
      arrToReturn.push([key, Number(value)]);
    });

    setChartData(arrToReturn);
    setChartType('PieChart');
    setIsLoading(false);
  };

  const handleBarChart = (keyName, arr) => {
    const arrToSet = [];

    arrToSet.push(Object.keys(arr[0]).map((key, i) => (i === 0 ? keyName : key)));
    arr.forEach(item => {
      arrToSet.push(Object.values(item).map(val => val));
    });
    setChartData(arrToSet);
    setChartType('Bar');
    setIsLoading(false);
  };

  const handleLoadAvgChart = (name, obj) => {
    const collectData = [];
    const tempObj = { ...obj };

    const { CPUCount } = sysinfo.cpu;
    const keys = Object.keys(tempObj).map(key => `${key.split('Loadavg')[1]} Min`);

    collectData.push(['CPU utilisation in %', ...keys]);
    Object.entries(tempObj).forEach(([key, value]) => {
      tempObj[key] = (value / CPUCount) * 100;
    });
    collectData.push([name, ...Object.values(tempObj)]);
    setChartData([...collectData]);
    setChartType('Bar');
    setIsLoading(false);
  };

  const handleChangeListItem = value => {
    setSelectedItem(value);
    setIsLoading(true);
    if (typeof sysinfo[value] === 'string') {
      setShowChartError(true);
      setIsLoading(false);
      return;
    }
    if (!Array.isArray(sysinfo[value])) {
      if (value === 'loadavg') {
        handleLoadAvgChart(value, sysinfo[value]);
      } else {
        handlePieChart(value, sysinfo[value], ignoreValues[value]);
      }
    } else {
      handleBarChart(value, sysinfo[value]);
    }
    if (showChartError) setShowChartError(false);
  };

  useEffect(() => {
         

    if (!utils.filterCustomer(userRole)) {
      
      const networkInfoObj = { ...sysinfo.networkInfo };
      const { ifConfig, vpnIp, modemInfo, arpTableOptions, ip4g, ...restObj } = networkInfoObj;
      sysinfo.networkInfo = restObj;
    }
    if (sysinfo && Object.keys(sysinfo).length) {
      if (sysinfo.time) {
        setTime(`Last Updated: ${utils.getDateTimeFormat(sysinfo.time, 'both')}`)
      }else {
        setTime('Sys Info update is in progress. Please check back in 1-2 minutes.')
      }
      if (userRole == 'admin' || userRole == 'user'){
        delete sysinfo.networkInfo.IP4G;
      }
      if (userRole === 'admin' || userRole === 'enterpriseAdmin') {
        const keysToDelete = [
          'CDM Check',
          'Management Agent Status',
          'EPIK Failover Update Status',
          'EPIK Rest Status'
        ];
      
        if (sysinfo.networkInfo) {
          keysToDelete.forEach(key => {
            if (key in sysinfo.networkInfo) {
              delete sysinfo.networkInfo[key];
            }
          });
        }
      }
      
    } 
    if (sysinfo && Object.keys(sysinfo).length && switchStatus) {
      const sortedKeys = sysInfoSortArr.sort((a, b) => {
        return sysInfoSortArr.indexOf(a) - sysInfoSortArr.indexOf(b);
      });
      if (!utils.filterCustomer(userRole)) {
        const tempArr = [...sortedKeys];
        const newArr = tempArr.map((item) => {
          if (item === 'networkInfo') {
            return item;
          }
        })
        const filteredArr = newArr.filter(item => item !== undefined);
        setSelectedItem(filteredArr[0]);
        setSortedArray(filteredArr);
      } else {
        setSelectedItem(sortedKeys[0]);
        setSortedArray(sortedKeys);
      }
      setIsLoading(false);
      setSwitchStatus(false);
    }
  }, [sysinfo]);

  const handleAbbreviation = (key) => {
    switch (key) {
      case 'CH':
        return 'CHICAGO';
      case 'LA':
        return 'LOS ANGELES';
      case 'NY':
        return 'NEW YORK';
      case 'ATL':
        return 'ATLANTA';
      case 'nyPingAvg':
        return 'NY';
        case 'DL':
          return 'DALLAS';
        case 'IR':
          return 'IRVINE';
      default:
        return utils.toTitleCase(key);
    }
  };

  const redColorStrings = ['Update Is Available', 'Unable to fetch data', 'No modem found', 'Not Installed', 'Not Registered', 'No modem found on the box', 'No IP found', 'Modem not found'];

  const secureInfo = getPermissionForComponent('secureInfo', user.permissionsGroup);
  
  const renderChart = () => {
    if (isLoading) {
      return <div>Loading...</div>;
    }
    if (eligible.some(item => item === selectedItem)) {

      const selectedOptions = sysinfo[selectedItem];

      if (secureInfo !== 'both' && secureInfo !== 'read') {
        delete selectedOptions['Tunnel IP'];
        delete selectedOptions['Modem Info'];
        delete selectedOptions['EPIK Rest Version'];
        delete selectedOptions['IP4G'];
        delete selectedOptions['ARP Table Options'];
        delete selectedOptions['Network Configuration'];
      }

      return (
        <div className={selectedItem === 'networkInfo' ? 'sysinfo-network' : 'sysinfo-text'}>
          {Object.entries(selectedOptions).map(([key, val]) =>
            selectedItem === 'networkInfo' ? (
              <>
               {key !== 'Device Firmware Version' && (
                  <h1 className="header-key">
                    {key}
                  </h1>
                )}
                <Row>
                  {typeof val === 'string' ? (
                    <Col sm={12} md={12}>
                      <span className="d-flex align-items-center justify-content-center span-error-lighter" style={{ color: redColorStrings.some(keyword => val.includes(keyword)) ? 'red' : '#3A5AA9' }} dangerouslySetInnerHTML={{
                        __html: val === 'N/A' || val === 'Null'
                          ? 'Data Not compatible with v2 firmware'
                          : val
                      }} />
                    </Col>
                  ) : Array.isArray(val) ? (
                    val?.map((val) => (
                      <>
                        {Object.entries(val).map(([keyHead, val]) => (
                          <>
                            {(
                              <Col sm={key === 'EPI Info' ? 12 : 6} md={key === 'EPI Info' ? 12 : 6}>
                                <ListGroup horizontal>
                                  <ListGroupItem className="list-group-sys">
                                    {keyHead}
                                  </ListGroupItem>
                                  {val?.map((value) =>
                                    <ListGroupItem>
                                      <span className="span-lighter" dangerouslySetInnerHTML={{ __html: value }} />
                                    </ListGroupItem>
                                  )}
                                </ListGroup>
                                <br />
                              </Col>
                            )}
                          </>
                        ))}
                      </>
                    ))
                  ) : (
                    Object.entries(val).map(([key, val]) => (
                      <Fragment key={key}>
                       {key === 'Version' && val.includes('\tEpik Firmware Version') ? (
                          <>
                            <Col sm={12}>
                              <div
                                style={{
                                  background: '#f2f2f2',
                                  padding: '15px',
                                  borderRadius: '5px',
                                  marginBottom: '15px',
                                }}
                              >
                                <div style={{ textAlign: 'center' }}>
                                  <h5
                                    style={{
                                      color: '#2d54a7',
                                      fontWeight: 'bold',
                                      margin: 0,
                                    }}
                                  >
                                    Device Firmware
                                  </h5>
                                </div>
                                <br />
                                <ListGroup horizontal>
                                  <ListGroupItem className="list-group-sys">
                                    Base Image
                                  </ListGroupItem>
                                  <ListGroupItem>
                                    <span
                                      className="span-lighter"
                                      style={{
                                        color: redColorStrings.some(keyword =>
                                          val?.includes?.(keyword)
                                        )
                                          ? 'red'
                                          : '',
                                      }}
                                    >
                                      {val?.includes?.('Epik Firmware Version')
                                        ? val.replace('Epik Firmware', '').trim()
                                        : val}
                                    </span>
                                  </ListGroupItem>
                                </ListGroup>
                              </div>
                            </Col>
                          </>
                        ) : (
                          <>
                            {key !== TIME_STAMP && key !== 'NY' && (
                              <Col sm={6} md={6}>
                                <ListGroup horizontal>
                                  <ListGroupItem className="list-group-sys">
                                    {key}
                                  </ListGroupItem>
                                  <ListGroupItem>
                                    <span
                                      className="span-lighter"
                                      style={{
                                        color: redColorStrings.some(keyword =>
                                          val?.includes?.(keyword)
                                        )
                                          ? 'red'
                                          : '',
                                      }}
                                    >
                                      {val}
                                    </span>
                                  </ListGroupItem>
                                </ListGroup>
                                <br />
                              </Col>
                            )}
                          </>
                        )}
                      </Fragment>
                    ))
                  )}
            </Row>
            </>
            ) : selectedItem === 'uptime' ? (
              <>
                {key} :{' '}
                <span className="span-lighter">
                  {val === 'N/A'
                    ? 'Data Not compatible with v2 firmware'
                    : val.replace('h', 'h : ').replace('m', 'm : ')}
                </span>
                <br />
              </>
            ) : selectedItem === 'portStatuses' ? (
              <div className={'flex-box'}>
                <span className="medium-text"> {key}: </span> &nbsp;
                <span className={'medium-text normal-font-weight'}>
                  {val === 'N/A' || val === 'Null' ? 'Data Not compatible with v2 firmware' : val}
                </span>
                <br />
              </div>
            ) : (
              <>
                {key} :{' '}
                <span className="span-lighter">
                  {val === 'N/A' || val === 'Null' ? 'Data Not compatible with v2 firmware' : val}
                </span>
                <br />
              </>
            ),
          )}
        </div>
      );
    }
    const showData =
      sysinfo[selectedItem] === 'N/A'
        ? 'Data Not compatible with v2 firmware'
        : sysinfo[selectedItem];
    return (
      <>
        {showChartError ? (
          <>
            <h1 className="header-key"> {utils.toTitleCase(selectedItem)}: </h1>
            <Row>
              <Col sm={12} md={12}>
                <span className="d-flex align-items-center justify-content-center span-error-lighter">
                  {showData}
                </span>
              </Col>
            </Row>
          </>
        ) : (
          <>
            <Chart
              chartType={chartType}
              loader={<div>Loading Chart</div>}
              data={chartData}
              options={pieOptions}
              graph_id={chartType}
              width="100%"
              height="400px"
              legend_toggle
            />
          </>
        )}
      </>
    );
  };

  return (
    <div>
      <div className='row' style={{ borderBottom: '1px solid #000' }} >
        <Col sm={12} md={12} lg={12} xs={12}>
          {sysLoading ? (
            <div className="error-msg d-flex flex-column justify-content-center align-items-center">
              <img src={logoLoading} className="loading-logo-sm" alt="loading" />
              <p className="text-align-center">Loading, Please wait...</p>
            </div>
          ) : sysinfo && Object.keys(sysinfo).length ? (
            <div> 
              <div className="select-wraper">
                
                <select
                  className="custom-select"
                  name="select-chart"
                  value={selectedItem}
                  onChange={e =>
                    objectCheck.some(item => item === e.target.value)
                      ? setSelectedItem(e.target.value)
                      : handleChangeListItem(e.target.value)
                  }
                >
                  {sortedArray
                    .filter(key => key !== 'operstate')
                    .map(item => (
                      <option key={item} className="chart-options" id={`test-${item}`} value={item}>
                        {item}
                      </option>
                    ))}
                </select>
              </div>
              {sysinfo.time && (
                <span>
                  Last Updated: 
                  <span style={{ color: utils.isOlderThan24Hours(sysinfo.time) ? 'red' : undefined, fontWeight: utils.isOlderThan24Hours(sysinfo.time) ? 500 : undefined }}>
                     {' '} {utils.getDateTimeFormat(sysinfo.time, 'both')}
                  </span>
                </span>
              )}
              <div style={{ minHeight: '420px' }}>{renderChart()}</div>
            </div>
          ) : (
            <div className="error-msg">No Data Found.</div>
          )}
        </Col>

      </div>
      <div className="row">
        <div className="col-md-9" />
        <div className="col-md-3">
          <div className="sysBtns">
            <button
              type="button"
              className="iconBtn"
              aria-label="Download results"
              onClick={onReloadSysInfo}
            >
                <span aria-hidden="true" role="presentation">
              <TooltipIcon
                tipId="sys-infp-download"
                imgSrc={pingSysinfoLogo}
                displayData="Download Results"
                placement="top"
                alt="Download results"
                aria-hidden="true"
              />
              </span>
            </button>

            <button
              type="button"
              className="iconBtn"
              aria-label="Query device for real-time details"
              onClick={onReloadInfo}
            >
                <span aria-hidden="true" role="presentation">
              <TooltipIcon
                tipId="query-real-time"
                imgSrc={fetchLogo}
                displayData="Query Device for Real-Time Details"
                placement="top"
                alt="Query device for real-time details"
                aria-hidden="true"
              />
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
});

export default SysInfo;
